/* tslint:disable */

declare var Object: any;
export interface SFProfileInterface {
  "id"?: number;
}

export class SFProfile implements SFProfileInterface {
  "id": number;
  constructor(data?: SFProfileInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SFProfile`.
   */
  public static getModelName() {
    return "SFProfile";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SFProfile for dynamic purposes.
  **/
  public static factory(data: SFProfileInterface): SFProfile{
    return new SFProfile(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SFProfile',
      plural: 'SFProfile',
      path: 'SFProfile',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/SFProfile.ts